/**
 * Component: Btn
 * ------------------------------------------------------------------------------
 * Scripts for static btn components
 *
 */
import classes from '~/config/classes'

/**
  * DOM selectors.
  */
 const selectors = {
   btn: '[js-btn="button"]',
 }

 /**
  * Create a new btn script.
  */
 export default () => {

   /**
    * Initialise component.
    */
   function init() {
    setEventListeners()
   }

   /**
    * Set event listeners.
    */
   function setEventListeners() {
    const buttons = [...document.querySelectorAll(selectors.btn)]

      buttons.forEach(btn => {
        btn.addEventListener('mouseenter', (event) =>{ handleButtonHover(event)} )
        btn.addEventListener('mouseleave', (event) =>{ handleButtonHover(event)} )
        btn.addEventListener('focusin', (event) =>{ handleButtonHover(event)} )
        btn.addEventListener('focusout', (event) =>{ handleButtonHover(event)} )
      })
   }

   /**
    * Handles transitioning the button icon animation on interaction.
    * @param  {Object} event - Pointer event.
    */
   function handleButtonHover(event) {
    const icons = [...event.target.querySelectorAll('.animated-icon__icon')]

    icons.forEach(icon => {
      icon.classList.toggle(classes.activeIcon)
    })
   }

   /**
    * Expose public interface.
    */
   return Object.freeze({
     init,
   })
 }
